module.exports = __webpack_public_path__ + "media/images/moving_truck_icon_inactive-4a750549.svg";